var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomBedroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 45,
    viewBox: "0 0 98 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_9278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6302 10.1701H80.4502L81.9502 2.81006H91.1302L92.6302 10.1701Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5403 10.1699V18.1199",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0701 18.4302H76.1101V43.8802H97.0701V18.4302Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1101 31.1602H96.9301",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 18.5698H65.12C67.05 18.5698 68.62 20.1398 68.62 22.0698V38.2698H0.75V22.0698C0.75 20.1398 2.32 18.5698 4.25 18.5698Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61011 38.27V44.87",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.76 38.27V44.87",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88989 18.6099C11.3299 15.3299 15.4699 13.1699 20.1699 13.1699C24.8099 13.1699 28.9099 15.2799 31.3699 18.4999",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 18.6099C40.44 15.3299 44.58 13.1699 49.28 13.1699C53.92 13.1699 58.02 15.2799 60.48 18.4999",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21997 18.61V2.15C4.21997 1.38 4.84997 0.75 5.61997 0.75H63.74C64.51 0.75 65.14 1.38 65.14 2.15V18.6",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_9278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.82,
    height: 44.87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBedroom);
export default __webpack_public_path__ + "static/media/roomBedroom.787a6663bdccc0ee59d405de5adabbb0.svg";
export { ForwardRef as ReactComponent };